import { cn } from "@/lib/utils"
import { MemberButton, memberButtonVariants } from "../fun-ui/MemberButton"
import { VipLogoLightIcon } from "../fun-ui/icons"
import { usePayment, useUser } from "@/stores/appStore";
import { VariantProps } from "class-variance-authority";
import { useRouter } from "next/navigation";
import { PaymentDialogCallback } from "@/stores/slices/paymentSlice";


export const useUpgradeVip = () => {
  const {
    openPayment,
  } = usePayment();
  const {
    user,
  } = useUser();
  const router = useRouter();
  return {
    upgradeVip: (params?: {
      activedPrice?: number;
      callback?: PaymentDialogCallback;
    }) => {
      const { activedPrice, callback } = params || {};
      if (user?.userId) {
        openPayment({
          type: 'upgrade',
          price: activedPrice,
          open: true,
        }, callback || null);
      } else {
        const href = `${location.origin}${location.pathname}?open=true&type=upgrade&price=${activedPrice}`;
        router.push(`/login?callback=${encodeURIComponent(href)}`); // 未登录，重定向到登录页面
      }
    }
  }
}
export interface UpgradeVipButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
  VariantProps<typeof memberButtonVariants> {
  iconOnly?: boolean;
  withoutIcon?: boolean;
  iconSize?: number;
  activedPrice?: number;
}
export const UpgradeVipButton = ({
  className,
  iconOnly = false,
  withoutIcon = false,
  iconSize = 16,
  children = '升级 Plus 会员',
  onClick,
  activedPrice,
  ...props
}: UpgradeVipButtonProps) => {
  const { upgradeVip } = useUpgradeVip();
  return (
    <MemberButton
      onClick={(evt) => {
        onClick?.(evt);
        upgradeVip({
          activedPrice,
        });
      }}
      className={cn(
        "flex items-center gap-2",
        className,
      )}
      {
      ...props
      }
    >
      {
        withoutIcon ? null : (
          <VipLogoLightIcon size={iconSize} />
        )
      }
      {
        iconOnly ? null : <span>{children}</span>
      }
    </MemberButton>
  )
}